// extracted by mini-css-extract-plugin
export default {"mainWrapper":"add-transport-detail_mainWrapper__8dYmR","sectionWrapper":"add-transport-detail_sectionWrapper__rfE6a","sidebarWrapper":"add-transport-detail_sidebarWrapper__dhI-N"};